export const DRAG_X_OFFSET = -10;
export const DRAG_Y_OFFSET = 5;
